export enum EXCEPTION_ACTION {
  SKIP = 'SKIP',
  POSTPONE = 'POSTPONE',
  MODIFY_AMOUNT = 'MODIFY_AMOUNT',
}
